<div class="av-rail__track" [style.top]="offset()" [class.av-rail__track--active]="active()">
  <div class="av-rail__sweep"></div>
</div>
